const env = process.env.NODE_ENV
const IP = {
  development: { // 本地开发环境
    baseIP: 'https://dev.spbcn.org/web_test/',
    pczxIP: 'https://ftalk-api-test.fengyongtech.com/', // 拼词之星app端
    pczxBaseIP: 'https://ftalk-backend.soullions.com/', // 拼词之星后台管理
    AIBaseIP: 'https://fesports-backend-test.fengyongtech.com/', // AI电竞大赛后台管理 --------旧接口迁移
    screenIP: 'https://fesports-api-test.fengyongtech.com/', // AI电竞大赛前端
    pczxWs: 'ws://8.145.35.121:7777'
    // baseIP: 'https://dev.spbcn.org/web/',
    // pczxIP: 'https://ftalk-api.fengyongtech.com/', // 为解决跨域问题将http改为https
    // AIBaseIP: 'https://fesports-backend.fengyongtech.com/', // 为解决跨域问题将http改为https
    // screenIP: 'https://fesports-api.fengyongtech.com/', // 为解决跨域问题将http改为https
    // pczxWs: 'ws://139.224.213.143:7777' // 为解决跨域问题将ws改为wss
  },
  production: { // 生产环境
    // baseIP: 'https://hy.spbcn.org/web_test/'
    baseIP: 'https://dev.spbcn.org/web/',
    pczxIP: 'https://ftalk-api.fengyongtech.com/', // 为解决跨域问题将http改为https
    pczxBaseIP: 'https://ftalk-backend.fengyongtech.com/', // 为解决跨域问题将http改为https
    AIBaseIP: 'https://fesports-backend.fengyongtech.com/', // 为解决跨域问题将http改为https
    screenIP: 'https://fesports-api.fengyongtech.com/', // 为解决跨域问题将http改为https
    pczxWs: 'ws://139.224.213.143:7777' // 为解决跨域问题将ws改为wss
  },
  test: { // 测试环境
    baseIP: 'https://dev.spbcn.org/web_test/',
    pczxIP: 'https://ftalk-api-test.fengyongtech.com/',
    pczxBaseIP: 'https://ftalk-backend.soullions.com/', // 拼词之星后台管理
    AIBaseIP: 'https://fesports-backend-test.fengyongtech.com/',
    screenIP: 'https://fesports-api-test.fengyongtech.com/',
    pczxWs: 'ws://8.145.35.121:7777'
  }
}
export default IP[env]
